import React from "react";

/*
props = {
  value: <number>
}
*/

const ChrPercentage = (props) => {
  return (
    <div> {`${props.value}%`} </div>
  )
}

export default ChrPercentage;
